import { render, staticRenderFns } from "./import-guide.vue?vue&type=template&id=2678919b&scoped=true&"
import script from "./import-guide.ts?vue&type=script&lang=ts&"
export * from "./import-guide.ts?vue&type=script&lang=ts&"
import style0 from "./import-guide.vue?vue&type=style&index=0&id=2678919b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2678919b",
  null
  
)

export default component.exports